import React, { forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import ja from "date-fns/locale/ja";
import TextField from "@mui/material/TextField";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
} from "./Word";

import "./InputDateStyle.css";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("ja", ja);

// 🎀 共通のカスタムインプット
const CustomInput = forwardRef(({ value, onClick, onChange, label }, ref) => (
  <TextField
    onClick={onClick}
    ref={ref}
    value={value}
    onChange={onChange}
    label={label}
  />
));

// 🎀 ReduxとURLパラメータの取得＆更新ロジックを共通化
const useDatePickerValue = (storeKey, actionType, key) => {
  const { b: building, page } = useParams();
  const value = useSelector(
    (state) => state[storeKey]?.[building]?.[page]?.[key]
  );
  const dispatch = useDispatch();

  const change = (newValue) => {
    dispatch({
      type: actionType,
      payload: { [key]: newValue },
      bulding: building,
      page,
    });
  };

  return { value, change };
};

// 🎀 ベースのDatePickerコンポーネント（超便利！）
const BaseDatePicker = ({
  storeKey,
  actionType,
  key_num1,
  placeholderText = "改善予定年月日", // ←✨デフォルト追加
  monthOnly = false,
}) => {
  const { value, change } = useDatePickerValue(storeKey, actionType, key_num1);

  return (
    <DatePicker
      locale="ja"
      selected={value ? new Date(value) : null}
      onChange={(date) => {
        const formattedDate = date ? date.toLocaleDateString("ja-JP") : null;
        change(formattedDate);
      }}
      dateFormat={monthOnly ? "yyyy/MM" : "yyyy/MM/dd"}
      showMonthYearPicker={monthOnly}
      calendarClassName="rasta-stripes"
      customInput={<CustomInput label={placeholderText} />}
    />
  );
};

// 🎀 建築系のDatePickerたち
export const InputDate = React.memo((props) => (
  <BaseDatePicker
    {...props}
    storeKey="Architecture"
    actionType={CHANGE_DATA_ARCHITECTURE}
  />
));

export const InputDateMonth = React.memo((props) => (
  <BaseDatePicker
    {...props}
    storeKey="Architecture"
    actionType={CHANGE_DATA_ARCHITECTURE}
    placeholderText="改善予定年月"
    monthOnly
  />
));

// 🎀 設備系のDatePickerたち
export const InputDateEquip = React.memo((props) => (
  <BaseDatePicker
    {...props}
    storeKey="Equipment"
    actionType={CHANGE_DATA_EQUIPMENT}
  />
));

export const InputDateMonthEquip = React.memo((props) => (
  <BaseDatePicker
    {...props}
    storeKey="Equipment"
    actionType={CHANGE_DATA_EQUIPMENT}
    placeholderText="改善予定年月"
    monthOnly
  />
));

// 🎀 消防設備系のDatePickerたち
export const InputDateFireEquip = React.memo((props) => (
  <BaseDatePicker
    {...props}
    storeKey="FireEquipment"
    actionType={CHANGE_DATA_FIREEQUIPMENT}
  />
));

export const InputDateMonthFireEquip = React.memo((props) => (
  <BaseDatePicker
    {...props}
    storeKey="FireEquipment"
    actionType={CHANGE_DATA_FIREEQUIPMENT}
    placeholderText="改善予定年月"
    monthOnly
  />
));
